import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
type SpeakerPresentation = {
  title: string;
  speaker: string;
  description: string;
  thumbnailUrl: string;
  role: string;
  videoUrl: string;
};
const presentations: SpeakerPresentation[] = [{
  title: 'Value Creation & Exit Strategy',
  speaker: 'Amanda Brown',
  description: 'Amanda shared how industrial net lease investments deliver immediate cash flow, stable long-term returns, and risk protection through creditworthy tenants in secondary U.S. markets.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qQZdsKNEtyJTtpbErtK1Nd/Screenshot_2025-09-17_at_7.36.42_AM.png',
  role: 'MAG Capital',
  videoUrl: 'https://fathom.video/share/h/TSZbhGuAyXEsEREdsbwJCR9TL3X9rEJe'
}, {
  title: 'How to Turn $500 into $40K Using an ESA',
  speaker: 'Daniel Tersey',
  description: 'Michael revealed unconventional financing strategies for real estate investors, including seller financing, subject-to deals, and private money partnerships that can help investors scale their portfolios without traditional bank loans.',
  thumbnailUrl: 'https://images.unsplash.com/photo-1560520031-3a4dc4e9de0c?q=80&w=1000&auto=format&fit=crop',
  role: 'Senior Account & Relationship Manager',
  videoUrl: 'https://fathom.video/share'
}, {
  title: 'Protecting Capital with First-Lien',
  speaker: 'Justin French',
  description: 'Learn how short-term, first-lien diversified notes can deliver fixed returns while protecting principal, with candid discussion on risk, transparency, and due diligence.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/koEumsgiSRNsoyECeDXTrX/Screenshot_2025-09-16_at_7.25.35_AM.png',
  role: 'Connect Invest',
  videoUrl: 'https://fathom.video/share/h/d4esj12VdotJYe8FmpynxSzKHzK5XAQ1'
}, {
  title: 'Pass-Through Function & Tax Savings',
  speaker: 'Nick Buhelos',
  description: 'Nick taught how to use holding companies, tax strategies, and business credit to protect assets, cut taxes, and scale investments.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iYUsNoSqpmFdFD7VGKYxrY/PCS_Logo.png',
  role: 'Prime Corporate Services',
  videoUrl: 'https://fathom.video/share/h/x9FADzG55HxQx52-5XEQmZ8J8za1Kvzd'
}, {
  title: 'Syndication Attorney',
  speaker: 'Bethany LaFlam',
  description: 'Bethany discusses securities regulations and options for real estate.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/33wsk7oCJsCJUoZMztSZnB/chrome_TrFW3vGtWy.png',
  role: 'Legal Expert',
  videoUrl: 'https://fathom.video/share/h/FfxyVqH18pf2ZW18gHTfc9KxiriaGzTC'
}, {
  title: 'Self-Directed IRA Strategies',
  speaker: 'Nate Hare',
  description: 'Learn about leveraging self-directed IRAs for real estate investment.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pQ13uTd5XQm98SQEJFbgJ2/chrome_aNXjz9xyqB.png',
  role: 'Directed IRA Specialist',
  videoUrl: 'https://fathom.video/share/h/FHvuef3y3p6QuUVMhV5y8jSx-c4ZGXx2'
}, {
  title: 'Whole Life Liquidity Strategies',
  speaker: 'Donald Pearson',
  description: 'Don explains four key risks and complexities of fixed income bond investing',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jP8GQfFC5zXbwczriDxNMj/image.png',
  role: 'WestPac Wealth Partners',
  videoUrl: 'https://fathom.video/share/h/wxzLm9nsyA6HrRvstcp44PJyY2QUVe36'
}, {
  title: 'Tax Advantages & Bonus Depreciation',
  speaker: 'Tony Shu',
  description: 'Tony highlights why mobile home parks are attractive investments: high returns, recession resilience, and rising demand for affordable housing.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k62XB3hfK4qutECreJQYS8/Screenshot_2025-09-12_at_7.39.12_AM.png',
  role: 'CEO and Co-Founder of Parker',
  videoUrl: 'https://fathom.video/share/h/T3hPxw-5NX5WzRHLsV8BsYeH3PYznyDu'
}, {
  title: 'The Three Capital-Raising Commandments',
  speaker: 'Adit Shah',
  description: 'Adit broke down the fundamentals of real estate syndications, sharing hard-earned lessons and a practical framework for raising capital responsibly while protecting investors and building long-term credibility.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/beNiNXV5y4ZLNDmaXUa9TV/Screenshot_2025-09-13_at_4.23.49_AM.png',
  role: 'Housebender | Abstract Works',
  videoUrl: 'https://fathom.video/share/h/C4rjc-t3XzBxds-s7XQiX-fDdMYzjxw4'
}, {
  title: 'Case Study: Automating Tenant Inquiries on Facebook Marketplace',
  speaker: 'Dean "GOGS" Valentini',
  description: 'A tactical session with Dean showing investors how to maximize time ROI, leverage automation and AI effectively, apply real-world tenant inquiry automations, and stay competitive by mastering AI.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1GPTmKUTByF4xYm2DTaR5e/Screenshot_2025-09-13_at_6.14.06_AM.png',
  role: '18 Alpha Investing',
  videoUrl: 'https://fathom.video/share/h/HSUs5GU19xkkhGVJqzUSSru_vWUt9zg9'
}, {
  title: 'Multiple VA Loan Purchases & Flexibility',
  speaker: 'Rick Sidley',
  description: 'A tactical session with lender Rick covering smart equity access, VA loan flexibility, DSCR loan strategies, and reverse 1031 exchanges for tax savings.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4aR8vptX4xW8h2FjT7ignd/Screenshot_2025-09-13_at_7.34.35_AM.png',
  role: 'Cornerstone First Mortgage',
  videoUrl: 'https://fathom.video/share/h/ASnSkKBAzuMdYhbRPHdJ2sqGXsT2FhsE'
}, {
  title: 'Neighbor.com Case Study: Turning an Empty Lot into Cashflow',
  speaker: 'Jason Fung',
  description: 'Jason shared a tactical case study on using Neighbor.com to turn unused property into passive income, and outlined how building a family office structure can preserve and grow generational wealth for real estate investors.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5h6EdPJ2CdwxKX1dBukymd/Screenshot_2025-09-14_at_6.00.25_AM.png',
  role: 'Founder, Maui Machines',
  videoUrl: 'https://fathom.video/share/h/B837vPM4iyPgfmVNDRmZx5bo2Tps-rNp'
}, {
  title: "Vetting Operator's Teams & Systems",
  speaker: 'Matthew Owens',
  description: 'Matt lays out a concise checklist to evaluate sponsors -- their team, systems, and controls, so you protect capital before you invest.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iqFd5iqKrKrUAzVPvS1saM/Screenshot_2025-09-14_at_7.20.36_AM.png',
  role: 'OCG Capital',
  videoUrl: 'https://fathom.video/share/h/sESmyfTy8oNA6W5v1xrUwY-myS8aMZsz'
}, {
  title: 'Why Conversions Beat Ground-Up in Self-Storage',
  speaker: 'Casper & Olga Bahlmann',
  description: 'Casper & Olga shared how they scale self-storage through high-margin conversion projects, recession-resilient market strategies, and disciplined underwriting that attracts institutional buyers.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bLoQ4VBsPXuWhFQii7Z5r2/Screenshot_2025-09-16_at_5.57.43_AM.png',
  role: 'Bhalmann Group',
  videoUrl: 'https://fathom.video/share/h/cnCv94Drfb1yNNLLTipppF_vP1EUbx64'
}, {
  title: 'Dynamic Equity for Strong Partnerships',
  speaker: 'Michael Cragholm',
  description: 'Mike shared his journey from Marine to founder, showing how he built GrapplApp and Space Coast Mobile Jiu Jitsu by leveraging niche demand, dynamic equity structures, and scalable tech -- offering investors practical lessons in branding, partnerships, and low-cost growth.',
  thumbnailUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/doKAmPNmwMEFLdM4xpp5fH/Screenshot_2025-09-17_at_3.06.43_AM.png',
  role: 'GrapplApp',
  videoUrl: 'https://fathom.video/share/h/zo6WZJ-JFDFY3CJ83vvFXi1pyif82EvG'
}];
export function PresentationsPage() {
  return <div className="bg-black" data-id="element-467">
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-gray-900 to-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-468">
        <div className="max-w-5xl mx-auto text-center" data-id="element-469">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" data-id="element-470">
            Expert <span className="text-[#4a7c59]" data-id="element-471">Presentations</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-472">
            Access our library of expert presentations covering real estate
            investing, tax strategies, legal considerations, and more.
          </p>
        </div>
      </section>
      {/* Presentations Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-473">
        <div className="max-w-7xl mx-auto" data-id="element-474">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-475">
            {presentations.map((presentation, index) => <div key={index} className="bg-black rounded-lg overflow-hidden border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300" data-id="element-476">
                <a href={presentation.videoUrl} target="_blank" rel="noopener noreferrer" className="block" data-id="element-477">
                  <div className="relative" data-id="element-478">
                    <img src={presentation.thumbnailUrl} alt={`${presentation.title} Presentation`} className="w-full h-48 object-cover" data-id="element-479" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/40 flex items-center justify-center" data-id="element-480">
                      <div className="bg-[#4a7c59] rounded-full p-2 shadow-lg transform transition-transform hover:scale-110" data-id="element-481">
                        <PlayCircleIcon className="w-10 h-10 text-white" data-id="element-482" />
                      </div>
                    </div>
                  </div>
                  <div className="p-6" data-id="element-483">
                    <h3 className="text-xl font-bold mb-2" data-id="element-484">
                      {presentation.title}
                    </h3>
                    <div className="mb-4" data-id="element-485">
                      <p className="text-[#4a7c59] font-semibold" data-id="element-486">
                        {presentation.speaker}
                      </p>
                      <p className="text-gray-400 text-sm" data-id="element-487">
                        {presentation.role}
                      </p>
                    </div>
                    <p className="text-gray-300 text-sm" data-id="element-488">
                      {presentation.description}
                    </p>
                    <div className="mt-4 text-[#4a7c59] hover:text-white font-semibold text-sm flex items-center" data-id="element-489">
                      Watch Presentation
                      <PlayCircleIcon className="w-4 h-4 ml-2" data-id="element-490" />
                    </div>
                  </div>
                </a>
              </div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#4a7c59]" data-id="element-491">
        <div className="max-w-4xl mx-auto text-center" data-id="element-492">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-493">
            Ready to Apply?
          </h2>
          <p className="text-xl mb-10" data-id="element-494">
            Join our community to access exclusive content and connect with
            expert presenters.
          </p>
          <a href="https://calendly.com/gregnamrow/1v1-meeting-tacticalinvestormastermind" target="_blank" rel="noopener noreferrer" className="bg-white text-black hover:bg-gray-200 font-bold py-3 px-8 rounded-md text-lg inline-block" data-id="element-495">
            Apply Now
          </a>
        </div>
      </section>
    </div>;
}